<template>
  <div class="mobile-store-block">
<!--    <template v-if="ad" v-html="getIframe"></template>-->
    <div class="mobile-store__inner">
      <div class="mobile-store__head">
        <div class="mobile-store__logo">
          <AppIcon/>
        </div>
        <div class="mobile-store__title">
          <span>Fyrsta bílasölu-<br/> appið á Íslandi!</span>
        </div>
      </div>
      <div class="mobile-store__body">
        <div class="mobile-store__description">
          <p>Verðvakt lætur þig vita ef verðið á draumabílnum lækkar.</p>
        </div>
        <div class="store-imgs">
          <a-blank href="https://apps.apple.com/app/apple-store/id1489190302?pt=120497884&ct=BilaskraApp&mt=8"
                   class="apple-store-img">
            <img :src="appleImgUrl" alt="">
          </a-blank>
          <a-blank href="https://play.google.com/store/apps/details?id=com.bilaskra.app"
                   class="android-store-img">
            <img :src="androidImgUrl" alt="">
          </a-blank>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppIcon from "@/components/svg/AppIcon"
import host from "@/helpers/getBaseUrl"
import ABlank from "@/components/ABlank";
import ad from "@/mixins/ad";

export default {
  props: {
    ad: {
      type: Object
    }
  },
  mixins: [ad],
  components: {
    AppIcon,
    ABlank
  },
  computed: {
    appleImgUrl() {
      return `${host()}/img/page-about-project/applestore.png`
    },
    androidImgUrl() {
      return `${host()}/img/page-about-project/android-app.png`
    }
  },
  mounted() {
    //console.log("!!!!!!!!!",this.ad.mobile_iframe);
    //setTimeout(() => {
      if(this.getIframe && this.getIframe.search("<script") >= 0 && this.getScriptUrl){
        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src',this.getScriptUrl)
        document.head.appendChild(recaptchaScript)
      }
    //},4 * 1000);
/*
    const css = document.createElement('style');
    css.type = 'text/css';
    const styles = 'body, html { background: none;}';

    css.appendChild(document.createTextNode(styles));
    setTimeout(() => this.$el.querySelector('iframe').contentDocument.head.appendChild(css), 500)

 */
  },
}
</script>
